import { BE_ADMIN_BASE } from "./environment";
import { apiGet, apiPost } from "./apiClient";

export const searchAirportAutocomplete = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/airport/autocomplete`, payload, opts);

export const fetchAirportsByQueryAPI = (query, opts) =>
  apiGet(`${BE_ADMIN_BASE}/airport/fetch/${encodeURIComponent(query)}`, opts);
